module.exports = __webpack_public_path__ + "static/img/login.fdf13c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/login.png
// module id = O2+P
// module chunks = 1